<template>

  <files-list :files="files" :readonly="!asset.id" @upload="upload($event)" @remove="remove($event)"></files-list>

</template>

<script>
  import FilesList from '../../files/components/files-list'

  export default {
    name: 'asset-files',

    props: [ 'asset' ],

    data () {
      return {
        files: []
      }
    },

    methods: {
      async refresh () {
        if (!this.asset.id)
          return this.files = []

        const response = await this.$store.dispatch('lazyItems/getItems', {
          model: 'files',
          params: {
            assetId: this.asset.id,
            limit: null
          }
        })

        this.files = response ? response.items : []
      },

      async upload (file) {
        const formData = new FormData()
        formData.append('file', file)

        const response = await this.$store.dispatch('uploadFile', {
          modelName: 'asset',
          modelItemId: this.asset.id,
          formData: formData,
          resize: true
        })

        await this.refresh()
        this.$emit('change', response.data)
      },

      async remove (id) {
        const item = [].concat(...this.files.map(file => file.filesInAsset)).find(x => x.fileId === id)

        await this.$store.dispatch('destroyItem', {
          model: { name: 'files-in-assets' },
          id: item.id
        })

        await this.refresh()
        this.$emit('remove', item.id)
      }
    },

    created () {
      this.refresh()
    },

    components: {
      FilesList
    }
  }
</script>

<style scoped lang="scss">

</style>
